import { Routes, Route, Navigate } from 'react-router-dom';
import { PortalProvider } from './context/PortalContext';
import { PortalLayout } from './components/Layout/PortalLayout';
import { ProtectedRoute } from './components/Layout/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';
import { LookupPage } from './pages/LookupPage';
import { ManagePage } from './pages/ManagePage';
import { RenewPage } from './pages/RenewPage';
import { PurchasePage } from './pages/PurchasePage';
import { ProductPurchasePage } from './pages/ProductPurchasePage';
import { PurchaseCompletePage } from './pages/PurchaseCompletePage';
import { NotFoundPage } from './pages/NotFoundPage';

export default function App() {
    return (
        <ErrorBoundary>
            <PortalProvider>
                <PortalLayout>
                    <Routes>
                        <Route path="/" element={<Navigate to="/lookup" replace />} />
                        <Route path="/lookup" element={<LookupPage />} />
                        <Route
                            path="/manage"
                            element={
                                <ProtectedRoute>
                                    <ManagePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/renew"
                            element={
                                <ProtectedRoute>
                                    <RenewPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/purchase" element={<PurchasePage />} />
                        <Route
                            path="/purchase/:slug/complete"
                            element={<PurchaseCompletePage />}
                        />
                        <Route path="/purchase/:slug" element={<ProductPurchasePage />} />
                        {/* Legacy redirect: /upgrade → /purchase/url-editor */}
                        <Route
                            path="/upgrade"
                            element={<Navigate to="/purchase/url-editor" replace />}
                        />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </PortalLayout>
            </PortalProvider>
        </ErrorBoundary>
    );
}
